export const fmtMoney = (n, currency = "USD") => {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(Number(n));
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
};

export const fmtShortDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch {
    return "—";
  }
};

export const calcBmi = (cm, kg) => {
  const h = Number(cm) / 100;
  const w = Number(kg);
  if (!h || !w) return "";
  return (w / (h * h)).toFixed(1);
};

// US/Imperial helpers — most US members think in feet/inches and pounds.
// We convert to metric before storing so the backend & physician portal
// stays single-unit (cm, kg) under the hood.
export const ftInToCm = (ft, inches) => {
  const f = Number(ft) || 0;
  const i = Number(inches) || 0;
  if (f === 0 && i === 0) return "";
  return Math.round((f * 12 + i) * 2.54);
};
export const lbsToKg = (lbs) => {
  const n = Number(lbs);
  if (!n) return "";
  return Math.round(n * 0.453592 * 10) / 10; // one decimal kg
};
export const cmToFtIn = (cm) => {
  const n = Number(cm);
  if (!n) return { ft: "", in: "" };
  const totalIn = Math.round(n / 2.54);
  return { ft: Math.floor(totalIn / 12), in: totalIn % 12 };
};
export const kgToLbs = (kg) => {
  const n = Number(kg);
  if (!n) return "";
  return Math.round(n / 0.453592);
};

// Capitalize the first letter of every word. Handles apostrophes, hyphens,
// multiple spaces gracefully ("o'connor" → "O'Connor", "mary-jane" → "Mary-Jane").
export const titleCase = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/(^|[\s\-'])([a-z])/g, (_, sep, ch) => sep + ch.toUpperCase());

// Strip everything except digits.
export const onlyDigits = (s) => (s || "").replace(/\D/g, "");

// Normalize a phone input to the 10-digit US NANP number by stripping the
// leading US country code `1` if present (iOS AutoFill / paste often
// prepends "+1 " to contact phone numbers).
const normalizeUs10 = (s) => {
  const d = onlyDigits(s);
  if (d.length === 11 && d.startsWith("1")) return d.slice(1);
  return d;
};

// Format a string as a US phone number while the user types.
// Accepts any input (including "+1 (469) 863-2468" from iOS AutoFill),
// formats up to 10 digits as (XXX) XXX-XXXX.
export const formatPhoneUS = (s) => {
  const d = normalizeUs10(s).slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// Convert a US phone display value to E.164 for storage / API submission.
// Returns "+15551234567" for a valid 10-digit US number; otherwise the
// original input untouched (let the backend reject if invalid).
export const phoneToE164 = (s) => {
  const d = normalizeUs10(s);
  if (d.length === 10) return `+1${d}`;
  return s || "";
};
